import $ from 'jquery';

export default function () {
	const $accordionHeaders = $('.accordion__header');
	$accordionHeaders.on('click', (event) => {
		event.preventDefault();// prevent jumping around fix

		const $header = $(event.currentTarget);

		var fold = $header.closest(".accordion__fold");
		const id = $header.attr('for');

		
		var checkbox = $(`#${id}`);
		checkbox.is(':checked') ? checkbox.prop('checked', false) : checkbox.prop('checked', true);
		// $("#"+id).prop("checked",true);
		if (id){
			//console.log(id+"FO");
			//window.location.hash = id;			
		}
		//quick fix for sliders not initializing in accordions
		setTimeout(function(){
			if(checkbox.is(':checked')){
				var tScroll = fold.offset().top - $("header.header").height();
				

				$("body,html").stop().animate({scrollTop:tScroll}, 500, 'swing');
			}

			$(window).trigger("resize");
			$(document).trigger("accordion_open",fold);			
		},100);	
  });
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/accordion.js